import { GetAgentModel } from "@factory/model/query-model-agent";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { agentFormDefault } from "./form.default";
import { AgentFormSchema } from "./form.rule";

export const useFormDefaultAgent = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetAgentModel | undefined) => {
    return !cachedValue
      ? agentFormDefault
      : ({
          code: cachedValue.code,
          name: cachedValue.name,
          email: cachedValue.email,
          address: cachedValue.address,
          contactNumber: cachedValue.contact_number,
          markupPercentage: cachedValue.markup_percentage,
        } as AgentFormSchema);
  };

  return {
    getDefault,
  };
};
